import React from 'react';
import styled from 'styled-components';
import { Tag } from '../tag/Tag';
import { CloseIcon } from '../icons/CloseIcon';
import ColorConstants from '../../../shared/constants/ColorConstants';

const stopEventPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
};

const defaultProps = {
    children: null,
    removeProps: {},
};

export const SelectMultiValue = ({
    data,
    children,
    removeProps,
    selectProps,
}) => (
    <SelectMultiValueTag
        onMouseDown={stopEventPropagation}
        onTouchEnd={stopEventPropagation}
        title={data.label}
        data-testid={selectProps?.testIds?.MultiValue && `${selectProps?.testIds?.MultiValue}-${data.value}`}
    >
        { children || data.label }
        { data.disabled
            ? null
            : (
                <SelectMultiValueCloseIcon
                    width="16px"
                    height="16px"
                    {...removeProps}
                    data-testid={selectProps?.testIds?.MultiValueClose && `${selectProps?.testIds?.MultiValueClose}-${data.value}`}
                />
            )
        }
    </SelectMultiValueTag>
);

SelectMultiValue.defaultProps = defaultProps;

export const SelectMultiValueStyles = () => ({});

export const SelectMultiValueTag = styled(Tag)`
    color: ${ColorConstants.white};
    background-color: ${ColorConstants.portage};
    font-size: 16px;
    line-height: 18px;
`;

export const SelectMultiValueCloseIcon = styled(CloseIcon)`
    margin-left: 8px;
    vertical-align: text-bottom;

    .icon-path {
        fill: ${ColorConstants.white};
    }
    
    &:hover .icon-bg {
        fill: ${ColorConstants.white};
        opacity: 0.2;
    }
`;
